<template>
  <div>
    <b-card>
      <b-row>
        <b-col md="3">
          <b-link :to="{ name: 'MerchantsHostingPage-list' }">
            <feather-icon icon="ArrowLeftIcon" />
            <span class="align-middle ml-50">Back to List</span>
          </b-link>
        </b-col>
      </b-row>

      <b-card-header>
        <h3>
          Details Merchant :
          <strong>{{ this.detailMerchantFormData.merchant }}</strong>
        </h3>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col md="6">
            <b-form-group>
              <img :src="detailMerchantFormData.logoPath" width="300" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <strong>Title Name: </strong>
              <span>{{ detailMerchantFormData.titleName }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Background Color: </strong>
              <span>{{ detailMerchantFormData.backgroundColor }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Header Color: </strong>
              <span>{{ detailMerchantFormData.headerColor }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Button Color: </strong>
              <span>{{ detailMerchantFormData.buttonColor }}</span>
            </b-form-group>
            <b-form-group>
              <strong>Text Color: </strong>
              <span>{{ detailMerchantFormData.textColor }}</span>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>

      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BCard,
  BCardBody,
  BCardHeader,
  BOverlay,
  BLink,
} from "bootstrap-vue";

import { required } from "@validations";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";

import axios from "@axios";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BCard,
    AppCollapse,
    AppCollapseItem,
    BCardBody,
    BCardHeader,
    BOverlay,
    BLink,
  },
  data() {
    return {
      isLoading: false,
      required,
      detailMerchantFormData: {
        backgroundColor: "",
        buttonColor: "",
        changedBy: "",
        changedOn: "",
        endDate: "",
        headerColor: "",
        id: "",
        isReadOnly: null,
        logoPath: "",
        merchant: null,
        merchantId: 0,
        recordStatus: 0,
        startDate: "",
        textColor: "",
        timeZoneInfo: null,
        titleName: "",
      },
      companyIdOptions: [],
      refundAccessTypeOptions: [
        { value: 1, text: "Gatway" },
        { value: 2, text: "Merchant" },
      ],
      selectedMerchantName: "",
      items: [
        {
          level: 1,
          userId: null,
          id: 0,
        },
      ],
      nextTodoId: 1,
      users: [],
      selelctedLevels: [],
      allUsers: [],
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "Merchants-View");
      axios.get("/Merchant/api/V1.0/Merchants/GetMerchants").then((res1) => {
        axios
          .get(
            `/Merchant/api/V1.0/Merchants/GetMerchantDetail?merchantId=${this.$route.params.id}`
          )
          .then((res2) => {
            this.detailMerchantFormData = res2;
            res1.merchants.filter((merchant) =>
              this.detailMerchantFormData.merchantId === merchant.id
                ? (this.detailMerchantFormData.merchant = merchant.name)
                : null
            );
            console.log(this.detailMerchantFormData);
            this.isLoading = false;
          })
          .catch((res) => {
            this.isLoading = false;
          });
      });
    },
  },
};
</script>
<style scoped></style>
